import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../components/HeaderAdmin';
import './AppSettings.css';
import { APP_SETTINGS } from '../ApiDetails.js';

function AppSettings() {

  const [HeadOfSecurityEmail, setHeadOfSecurityEmail] = useState('');

  useEffect(() => {
    setHeadOfSecurityEmail("");
  }, [location.state]);

  useEffect(() => {
    fetchAppsettings();
  }, []);

  const fetchAppsettings = async () => {
    try {
      const response = await axios.get(APP_SETTINGS);
      setHeadOfSecurityEmail(response.data.headOfSecurityEmail);
    } catch (error) {
      console.error('Error fetching family users:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      data.append("pHeadOfSecurityEmail", HeadOfSecurityEmail);
      await axios.post(APP_SETTINGS, data);
      alert("Application settings were sucessfully updated.")
    } catch (error) {
      console.error('Error saving app settings:', error);
      alert("Error on updating app settings.")
    }
  };

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className='row m-2'>
          <div className='m-2 bg-light rounded p-4'>
            <div className="large-custom-font">Update application settings</div>
          </div>
          <div className='m-2 bg-light rounded p-0'>
            <div className="m-3">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="HeadOfSecurityEmail" className="form-label">Mars&apos; head of security email</label>
                  <input
                    className="form-control"
                    id="HeadOfSecurityEmail"
                    value={HeadOfSecurityEmail}
                    onChange={(e) => setHeadOfSecurityEmail(e.target.value)}
                  />
                </div>

                <button type="submit" className="btn btn-primary">Update</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AppSettings;